import { selectCurrentContactOrCustomerEmail } from 'ducks/crm/contacts'

import doFetchMatchingObjects from 'ducks/integrations/salesforce/operations/doFetchMatchingObjects'

export default function doFetchMatchingObjectsForCurrentCustomer() {
  return (dispatch, getState) => {
    const state = getState()
    const email = selectCurrentContactOrCustomerEmail(state)
    dispatch(doFetchMatchingObjects(email))
  }
}
